var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPeople = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18.5,
  height: 18.5,
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {
    display: "block"
  }
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#726855",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.445
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.105 16.187a3.854 3.854 0 1 0-7.709 0M16.958 8.094a2.698 2.698 0 0 0-4.245-2.21M5.786 5.883a2.698 2.698 0 0 0-4.245 2.21"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.563 10.02a2.313 2.313 0 1 1-4.626 0 2.313 2.313 0 0 1 4.626 0M16.188 3.469a1.927 1.927 0 1 1-3.854 0 1.927 1.927 0 0 1 3.854 0M6.167 3.469a1.927 1.927 0 1 1-3.854 0 1.927 1.927 0 0 1 3.854 0"
}))));
export default SvgPeople;